// src/pages/DisplayEvent.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEvents } from "../../redux/eventSlice";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function DisplayEvent() {
  const dispatch = useDispatch();
  const { events, loading, error } = useSelector((state) => state.events);

  // Load events on mount
  useEffect(() => {
    dispatch(getEvents());
  }, [dispatch]);

  // Optional: show toast on error
 

  if (loading) return <div className="text-center p-4">Loading events...</div>;

  return (
    <div className=" min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 mb-14 pb-10  px-4 sm:mb-0 sm:pb-0">
      <h2 className="text-2xl font-bold m-2 mt-4 ">All Events</h2>

      {events.length === 0 ? (
        <p>No events found.</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {events.map((event) => (
            <div
              key={event.id}
              className="border rounded-lg p-4 shadow hover:shadow-lg transition"
            >
              {event.image && (
                <img
                  src={event.image}
                  alt={event.name}
                  className="w-full h-48 object-cover rounded mb-2"
                />
              )}
              <h3 className="font-semibold text-lg">{event.name}</h3>
              <p className="text-sm text-gray-600">
  {event.description.split(" ").length > 20
    ? event.description.split(" ").slice(0, 20).join(" ") + "..."
    : event.description}
</p>

              <Link
                to={`/display-event/event-detail/${event.id}`}
                className="mt-2 inline-block text-blue-600 hover:underline"
              >
                View Details
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}